var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultiGuest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9502 18.3946C22.0558 18.1594 24.432 17.2416 24.432 14.7814C24.432 11.8388 21.0524 11.0762 17.0476 11.0762C15.1607 11.0762 13.4042 11.2413 12.0781 11.7281C16.2879 12.1792 19.355 13.5176 19.355 16.6324C19.355 17.2991 19.2137 17.8835 18.9502 18.3946Z",
    fill: "#777E91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1796 9.17564C15.7106 9.37247 16.2873 9.48003 16.891 9.48003C19.5653 9.48003 21.7081 7.37047 21.7081 4.73957C21.7081 2.10866 19.5653 0 16.891 0C15.9536 0 15.0813 0.259248 14.3438 0.709355C15.4565 2.00094 16.1267 3.68629 16.1267 5.53763C16.1267 6.86314 15.7831 8.10371 15.1796 9.17564Z",
    fill: "#777E91"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.429688 16.6015C0.429688 19.6911 4.42351 20.492 9.15369 20.492C13.8588 20.492 17.8777 19.7195 17.8777 16.6287C17.8777 13.5391 13.885 12.7383 9.15369 12.7383C4.4486 12.7383 0.429688 13.5107 0.429688 16.6015Z",
    fill: "#777E91"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.87058 11.0767C11.9953 11.0767 14.499 8.61182 14.499 5.53781C14.499 2.46381 11.9953 0 8.87058 0C5.74689 0 3.24219 2.46381 3.24219 5.53781C3.24219 8.61182 5.74689 11.0767 8.87058 11.0767Z",
    fill: "#777E91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiGuest);
export default __webpack_public_path__ + "static/media/multi-guest.d65e20a7672a7ede91d5e5ef203b42b6.svg";
export { ForwardRef as ReactComponent };